import { Component, inject, OnInit, signal } from "@angular/core";
import { BannerComponent } from "./components/banner/banner.component";
import { IntroduceComponent } from "./components/introduce/introduce.component";
import { CourseCategoriesComponent } from "./components/course-categories/course-categories.component";
import { TestimonialsComponent } from "./components/testimonials/testimonials.component";
import { FooterLandingComponent } from "./components/footer-landing/footer-landing.component";
import { CoursesComponent } from "./components/courses/courses.component";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonModule } from "@angular/common";
import { MatDialog } from "@angular/material/dialog";
import { AuthUtilitiesService } from "src/app/pages/auth/services/auth-utilities.service";
import { AuthState } from "src/app/pages/auth/models/auth.model";
import { AuthService } from "src/app/pages/auth/services/auth.service";
import { ResetPasswordComponent } from "./components/dialogs/reset-password/reset-password.component";

@Component({
  selector: "app-landing-page",
  imports: [
    BannerComponent,
    IntroduceComponent,
    TestimonialsComponent,
    FooterLandingComponent,
    CourseCategoriesComponent,
    CoursesComponent,
    CommonModule,
  ],
  templateUrl: "./landing-page.component.html",
  styleUrl: "./landing-page.component.scss",
})
export class LandingPageComponent implements OnInit {
  #route = inject(ActivatedRoute);
  #router = inject(Router);
  #dialog = inject(MatDialog);
  #authUtilities = inject(AuthUtilitiesService);
  #authService = inject(AuthService);

  openedDialog = signal<boolean>(false);

  ngOnInit(): void {
    // Which dialog this URL is asking for.
    //
    // Auth has no pages of its own — it is a dialog over whatever you were
    // looking at, which is the right shape for it. But "sign in" and "sign up"
    // are the two links most likely to be pasted into a chat or written into a
    // manual, and until now /auth/login answered 404. These routes open the
    // dialog over the landing page, exactly as /reset-password already did.
    const dialog = this.#route.snapshot.data?.["authDialog"];
    this.openedDialog.update(() => !!dialog);

    if (dialog === "reset") {
      this.openResetDialog();
    } else if (dialog) {
      // Which pane the dialog opens on. Set here rather than inside
      // AuthUtilitiesService: that service is what opens the dialog, and having
      // it reach back into AuthService closes an NG0200 cycle that takes the
      // whole app down on the first sign-in.
      const pane: Record<string, AuthState> = {
        register: AuthState.REGISTER,
        forgot: AuthState.FORGOT_PASSWORD,
        login: AuthState.UNAUTHORIZED,
      };
      this.#authService.updateAuthState(pane[dialog] ?? AuthState.UNAUTHORIZED);
      this.#authUtilities.openLoginDialog();
    }
  }

  openResetDialog() {
    const dialogRef = this.#dialog.open(ResetPasswordComponent, {
      height: "auto",
      maxHeight: "90vh",
      minHeight: "30vh",
      width: "480px",
      disableClose: true,
      panelClass: "dialog-rounded-4",
      // backdropClass: "bg-primary",
    });
  }
}
